import { inject, Injectable } from '@angular/core';
import { ToastService } from '@shared/components/toast';
import { catchError, filter, of, switchMap, tap } from 'rxjs';
import { ConfirmationModalComponent } from './confirmation-modal.component';
import { Dialog } from '@angular/cdk/dialog';
import { ExecuteWithConfirmationParams } from './confirmation-modal.model';

@Injectable({ providedIn: 'root' })
export class ConfirmationModalService {
  private readonly _dialog = inject(Dialog);
  private readonly _toast = inject(ToastService);

  public executeWithConfirmation(config: ExecuteWithConfirmationParams) {
    const dialogRef = this._dialog.open(ConfirmationModalComponent, {
      data: config.confirmData,
    });

    return dialogRef.closed.pipe(
      filter((confirmed) => !!confirmed),
      switchMap(() => config.onConfirm()),
      tap(() => this._toast.show(config.toastMessages.success)),

      catchError(() => {
        this._toast.show(config.toastMessages.error);
        return of(null);
      }),
    );
  }
}
